import {
    useLocation } from "react-router-dom";
import useUiController from "../global/hooks/useUiController";
import SnpBaseLayout from "../global/SnpBaseLayout";
import AddProduct from "./mart/AddProduct";
import { useEffect } from "react";
import {
  CartDets,
  printDebugLog
} from "../../constants/constant";
import { useSelector } from "react-redux";
import GoldInventory from "./gold/GoldInventory";

const AddProductBase = () => {

  const {
    loader,
    setLoader,
    snackbarConfig,
    showSnackbar,
    closeSnackbar,
    dialogConfig,
    showDialog,
    closeDialog,
  } = useUiController();

  const location = useLocation();
  const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
  useEffect(() => {
    printDebugLog("AddProductBase", location.state);
  }, [location.state,storeActiveShopHash]);

  return (
    <SnpBaseLayout
      loader={loader}
      snackbarConfig={{ ...snackbarConfig, onClose: closeSnackbar }}
      dialogConfig={dialogConfig}
    >
      {
        storeActiveShopHash.cartType === CartDets.Gold ?
          <GoldInventory showSnackbar={showSnackbar}
            setSnpLoader={setLoader}
            snpLoader={loader}
            dialogConfig={dialogConfig}
            showDialog={showDialog}
            closeDialog={closeDialog}
            productProps={location.state} /> :
          <AddProduct
            showSnackbar={showSnackbar}
            setSnpLoader={setLoader}
            snpLoader={loader}
            dialogConfig={dialogConfig}
            showDialog={showDialog}
            closeDialog={closeDialog}
            productProps={location.state}
          />
      }
      

    </SnpBaseLayout>
  )
};
export default AddProductBase;